<template>
	<!--<div class="nav nav-pills">
		<div class="btn-group overflow-auto" role="group" aria-label="Basic example">
			<button
				v-for="tab in tabs"
				class="btn btn-secondary" 
				:id="'nav-option-'+tab.field" 
				@click="nav_change(tab.field)">
				{{ tab.label }}
			</button>
		</div>
	</div>-->

	<ul class="navbar-nav mr-auto">
		<li class="nav-item" v-for="tab in tabs">
			<a 
				class="nav-link" 
				:id="'nav-option-'+tab.field" 
				@click="nav_change(tab.field)">
					{{ tab.label }}
			</a>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
	        tabs: {
	            type: Array
	        },
	    },

		mounted(){
			// set o primeiro enviado como ativo
			if($('#nav-option-'+this.tabs[0]['field']).hasClass('active')){
				document.getElementById('nav-option-'+this.tabs[0]['field']).classList.remove("active");
			}
			var el = document.getElementById('nav-option-'+this.tabs[0]['field']);
			el.classList.add("active");
		},

		methods: {
			nav_change(tab){
				for (var i=0; i<this.tabs.length; i++) {
					if($('#nav-option-'+this.tabs[i]['field']).hasClass('active')){
						var el = document.getElementById('nav-option-'+this.tabs[i]['field']);
						el.classList.remove("active");
					}
				}

				var el = document.getElementById('nav-option-'+tab)
				el.classList.add("active");

				this.$emit('navChanged', tab);
			},
		}
	}
</script>

<style scoped>
	.cl-blue {
		color: blue;
	}
	.nowrap {
		white-space:nowrap;
	}
	.nav-link {
		cursor: pointer;
	}
</style>